const KNOWN_ROLE_FLAGS = ['admin', 'planner', 'promoter', 'agent', 'staff', 'buyer'];

export const normalizeRole = (value) => {
  if (!value) return null;
  const roleString = value.toString().toUpperCase().replace(/^ROLE_/, '').trim();
  return roleString || null;
};

export const gatherRoleCandidates = (user) => {
  const candidates = [];
  if (!user) return candidates;

  if (user.role) candidates.push(user.role);
  if (Array.isArray(user.roles)) candidates.push(...user.roles);

  if (Array.isArray(user.authorities)) {
    user.authorities.forEach((entry) => {
      if (!entry) return;
      if (typeof entry === 'string') {
        candidates.push(entry);
      } else {
        candidates.push(entry.authority || entry.role || entry.name);
      }
    });
  }

  if (Array.isArray(user.permissions)) {
    candidates.push(...user.permissions);
  }

  return candidates;
};

export const extractRoleFromUser = (user, fallback = null, validRoles = []) => {
  const candidates = gatherRoleCandidates(user);
  for (const candidate of candidates) {
    const normalized = normalizeRole(candidate);
    if (normalized && (!validRoles.length || validRoles.includes(normalized))) {
      return normalized;
    }
  }
  for (const flag of KNOWN_ROLE_FLAGS) {
    if (user?.[flag]) {
      const upper = flag.toUpperCase();
      if (!validRoles.length || validRoles.includes(upper)) {
        return upper;
      }
    }
  }
  return fallback;
};

export const userHasAnyRole = (user, allowedRoles = []) => {
  if (!user) return false;
  if (!allowedRoles || allowedRoles.length === 0) return true;

  const roleSet = new Set();
  gatherRoleCandidates(user).forEach((candidate) => {
    const normalized = normalizeRole(candidate);
    if (normalized) roleSet.add(normalized);
  });

  KNOWN_ROLE_FLAGS.forEach((flag) => {
    if (user[flag]) roleSet.add(flag.toUpperCase());
  });

  return allowedRoles.some((role) => roleSet.has(role.toUpperCase()));
};
